export default {"src":"/_next/static/media/Others App Permission.de689e0f.gif","height":666,"width":684,"blurWidth":0,"blurHeight":0};